
const statusColor = (status) =>
  status ? { color: "text-green" } : { color: "text-lg7" };

const mapCylinderRequestStatus = {
  0: { value: "Pending", color: "text-red-1" },
  1: { value: "Partially Completed", color: "text-yellow-600" },
  2: { value: "Done", color: "text-green-3" },
  3: { value: "Cancelled", color: "text-lg7" },
};
export const CylinderFillStatus = ({ status }) => {
  if (status === undefined) return "-";
  const { color } = statusColor(status);
  return <span className={`${color}`}>{status ? "Filled" : "Empty"}</span>;
};

export const CylinderRequestStatus = ({ status }) => {
  const { value, color } = mapCylinderRequestStatus[status] || {};
  return (
    <span className={`text-sm text-center ${color}`}>{value || "Unknown"}</span>
  );
};
